import { AssetFile } from "../../types/contentfulTypes"

const calculatePosition = (image: AssetFile, arrayLength: number, index: number) => {
  const isHorizontal = image?.file?.details?.image?.width > image?.file?.details?.image?.height
  const isDesktop =
    image?.title?.includes("Mac") ||
    image?.title?.includes("iPad") ||
    image?.title?.includes("Keyboard")
  const position = index + 1

  // Left position
  const startLeftPosition = arrayLength > 6 && !isHorizontal ? -40 : isDesktop ? -70 : -100
  const leftMultiplicator = arrayLength > 6 ? (isDesktop ? 20 : 30) : 50
  const left = `${
    !isHorizontal || isDesktop ? startLeftPosition + position * leftMultiplicator : "35px"
  }px`

  // Top position
  const startTopPosition = isDesktop ? 100 : 50
  const top = `${isHorizontal ? startTopPosition + position * (isDesktop ? 10 : 30) : "100"}px`

  return {
    left,
    top,
  }
}

export default calculatePosition
